import { createNode } from '@glueapp/graph-types';
import { TodoistIntegration } from './TodoistIntegration';

interface TodoistProject {
    id: number;
    name: string;
}

export const GetTodoistProjects = createNode({
    id: 'Get Todoist Projects',
    name: 'Get Todoist Projects',
    description: 'Get all your Todoist Projects',
    aiDescription:
        'Requires the Todoist integration to be connected. Takes no inputs. Outputs a "Projects" port containing an array of objects with "id" (number) and "name" (string) properties for each project in the connected Todoist account.',
    category: 'Todoist',
    color: '#e44232',
    integration: TodoistIntegration,
    inPorts: {},
    outPorts: {
        Projects: {
            kind: 'array',
            subType: {
                kind: 'object',
                restriction: 'open',
                properties: {
                    id: { kind: 'number' },
                    name: { kind: 'string' },
                },
            },
        },
    },
    isAsync: true,
    execute: async function (input) {
        try {
            const response = await input.integration.callIntegration<TodoistProject[]>({
                url: 'https://api.todoist.com/rest/v1/projects',
            });
            const projects: TodoistProject[] = response.data;
            return { output: { Projects: projects.map(project => ({ id: project.id, name: project.name })) } };
        } catch {
            return { output: { Projects: [] } };
        }
    },
});
